import React, { Component } from 'react';
import SystemTranslationLabelStatisticService from '../services/SystemTranslationLabelStatisticService';
import SystemTranslationStatistic from './SystemTranslationStatistic';
import { browserHistory } from 'react-router';
import { observer } from 'mobx-react';

class SystemTranslationLabelStatisticContainer extends Component {
  systemTranslationLabelSummaryService = new SystemTranslationLabelStatisticService();

  componentDidMount() {
    this.systemTranslationLabelSummaryService.load();
  }

  render() {
    return (
      <SystemTranslationStatistic
        title="Labels"
        value={this.systemTranslationLabelSummaryService.summary}
        icon="tags"
        fetching={this.systemTranslationLabelSummaryService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/localization',
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

export default observer(SystemTranslationLabelStatisticContainer);
